import * as React from 'react'
import { Input, } from '../../../Shared/index'

import useModalAccessiblity from '../../../Shared/hooks/useModalAccessibility'

export const SchoolNotListedModal = ({
  onChangeUnlistedSchoolName,
  unlistedSchoolName,
  onChangeUnlistedSchoolZipcode,
  unlistedSchoolZipcode,
  submitSchoolNotListedInformation,
  show,
  close,
}) => {
  const { modalRef, } = useModalAccessiblity(close)

  React.useEffect(() => {
    if (show) {
      modalRef.current?.showModal();
    } else {
      modalRef.current?.close();
    }
  }, [show]);

  return (
    <dialog
      aria-labelledby="schoolNotListedModalTitle"
      aria-modal="true"
      className="school-not-listed-modal school-not-listed-modal-container quill-modal modal-body"
      onCancel={close}
      ref={modalRef}
    >
      <div>
        <h3 className="title" id="schoolNotListedModalTitle">School not listed?</h3>
      </div>
      <p>Please share your school name and ZIP code below. Quill will review and update our database.</p>
      <Input
        handleChange={onChangeUnlistedSchoolName}
        id="school-name"
        label="School name"
        type="text"
        value={unlistedSchoolName}
      />
      <Input
        handleChange={onChangeUnlistedSchoolZipcode}
        id="zipcode"
        label="ZIP code"
        type="text"
        value={unlistedSchoolZipcode}
      />
      <div className="form-buttons">
        <button className="quill-button-archived primary contained medium focus-on-light" onClick={submitSchoolNotListedInformation} type="button">Done</button>
      </div>
    </dialog>
  );
};

export default SchoolNotListedModal;
